import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faSave,
  faEdit,
  faCheck,
  faXmark,
  faFileLines,
  faPlus,
  faLanguage,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/Modal";
import { useState } from "react";
import { alertError, alertSuccess } from "../../../components/Alert";
import { updatePageHeaderData } from "../../../slices/panelSlice/pageHeaderSlice";
import { useSelector, useDispatch } from "react-redux";
import api from "../../../auth/api";
import { fetchPageHeaderData } from "../../../slices/panelSlice/pageHeaderSlice";
import LanguageTranslation from "../Language/LanguageTranslation";
import PageHeaderTranslation from "./PageHeaderTranslation";

const PageHeaderTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  optionList,
  languageList,
  editable,
}) => {
  const dispatch = useDispatch();
  const [transDis, setTransDis] = useState(false);
  const [transData, setTransData] = useState({});
  const [iconModalDis, setIconModalDis] = useState(false);
  const [iconObj, setIconObj] = useState({
    id: undefined,
    male: undefined,
    female: undefined,
    default: undefined,
  });

  const handleUpdateIcons = (currIconArr, id) => {
    const male = currIconArr.filter((f) => f.index === "male")[0];
    const female = currIconArr.filter((f) => f.index === "female")[0];
    const defaultIcon = currIconArr.filter((f) => f.index === "default")[0];

    setIconObj({
      id,
      male,
      female,
      default: defaultIcon,
    });

    setIconModalDis(true);
  };

  const handleTranslation = (data, id) => {
    setTransDis(true);
    setTransData({ data, id });
  };

  const handleUploadIcons = async (e, iconType) => {
    let imgFile = e.target.files[0];
    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
    ];

    if (!validImageTypes.includes(imgFile.type)) {
      alertError("Please upload a valid image file (JPEG, PNG, GIF, or WEBP).");
      return;
    }
    if (!imgFile) return;
    const maxSize = 500 * 1024;
    console.log(imgFile);
    if (imgFile.size > maxSize)
      return alertError("Icon size should be less than 500kb");
    let imgData;
    if (iconType === "default") {
      imgData = { icon_0: imgFile };
    } else if (iconType === "male") {
      imgData = { icon_1: imgFile };
    } else if (iconType === "female") {
      imgData = { icon_2: imgFile };
    }

    try {
      const resp = await api.patch(
        "/panel/pageHeader",
        { ...imgData, id: iconObj.id },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(resp.data);
      alertSuccess(resp.data.success);
      setIconModalDis(false);
      dispatch(fetchPageHeaderData());
    } catch (err) {
      console.log(err);
      alertError(err?.response?.data?.errors);
    }
  };

  return (
    <>
      <div className="tableContainer">
        <table className="table text-xs w-[88vw]" role="table">
          <thead className="stickyHeader bg-[var(--mainCol)] text-white">
            <tr>
              {headers?.map((header, index) => (
                <th className="p-1 text-left border" key={index}>
                  {header.toUpperCase()}
                </th>
              ))}
              {editable && <th className="p-1 text-left border">ACTION</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                {headers.map((header) => (
                  <td
                    key={header}
                    style={{
                      padding: "12px",
                      border: "1px solid #ddd",
                      textAlign: "left",
                    }}
                  >
                    {header === "Icon" && Array.isArray(row[header]) ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {row[header].map((iconData) => (
                          <div
                            key={iconData.id}
                            style={{ textAlign: "center" }}
                          >
                            <img
                              className="max-w-12 max-h-10"
                              src={iconData.icon}
                              alt={iconData.pagetitle}
                            />
                            <p style={{ margin: "5px 0", fontSize: "12px" }}>
                              {iconData.IconIndex}
                            </p>
                          </div>
                        ))}
                        {editable && (
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            onClick={() =>
                              handleUpdateIcons(row[header], row.id)
                            }
                          />
                        )}
                      </div>
                    ) : editRowId === row.id &&
                      editableFields.includes(header) ? (
                      header === "optionType" ? (
                        <select
                          value={editedData[header] || ""}
                          onChange={(e) => handleChange(e, header)}
                          style={{
                            width: "100%",
                            padding: "6px",
                            boxSizing: "border-box",
                            border: "1px solid",
                            color: "black",
                          }}
                        >
                          <option value="" disabled>
                            Select an option
                          </option>
                          {optionList?.result?.map((option, i) => (
                            <option key={i} value={option.title}>
                              {option.title}
                            </option>
                          ))}
                        </select>
                      ) : ["active", "status"].includes(header) ? (
                        <div className="cursor-pointer flex justify-center">
                          {editedData[header] === true && (
                            <FontAwesomeIcon
                              onClick={(e) => handleChange(e, header, true)}
                              value={true}
                              color="var(--green_Main)"
                              icon={faCheck}
                            />
                          )}
                          {editedData[header] === false && (
                            <FontAwesomeIcon
                              onClick={(e) => handleChange(e, header, false)}
                              color="indianred"
                              icon={faXmark}
                            />
                          )}
                        </div>
                      ) : (
                        <input
                          type="text"
                          value={editedData[header] || ""}
                          onChange={(e) => handleChange(e, header)}
                          onKeyUp={(e) => e.key === "Enter" && handleSave()}
                          style={{
                            width: "100%",
                            padding: "6px",
                            boxSizing: "border-box",
                            border: "1px solid",
                            color: "black",
                          }}
                        />
                      )
                    ) : header === "translate" &&
                      typeof row[header] === "object" ? (
                      <div
                        className="cursor-pointer flex items-center text-wrap"
                        onClick={() => handleTranslation(row[header], row.id)}
                      >
                        View Translations
                        <FontAwesomeIcon className="ml-2" icon={faLanguage} />
                      </div>
                    ) : row[header] === true ? (
                      <FontAwesomeIcon
                        className="ml-2"
                        color="var(--green_Main)"
                        icon={faCheck}
                      />
                    ) : row[header] === false ? (
                      <FontAwesomeIcon
                        className="ml-2"
                        color="indianred"
                        icon={faXmark}
                      />
                    ) : (
                      String(row[header])
                    )}
                  </td>
                ))}
                {editable && (
                  <td style={{ border: "1px solid #ddd" }}>
                    {editRowId === row.id ? (
                      <div className="flex justify-center">
                        <FontAwesomeIcon
                          className="p-2 cursor-pointer"
                          color="#67a97b"
                          onClick={handleSave}
                          icon={faSave}
                        />
                        <FontAwesomeIcon
                          className="p-2 cursor-pointer"
                          color="indianred"
                          onClick={handleCancel}
                          icon={faXmark}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-center">
                        <FontAwesomeIcon
                          className="cursor-pointer"
                          onClick={() => handleEdit(row.id)}
                          icon={faPenToSquare}
                        />
                        <FontAwesomeIcon
                          className="ml-2 cursor-pointer"
                          onClick={() => handleLog(row.id)}
                          icon={faFileLines}
                        />
                      </div>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={iconModalDis}
        onClose={() => setIconModalDis(false)}
        title="Add and Update Icons"
        content={
          <>
            <div className="flex justify-between items-center mt-2">
              <div>Male</div>
              <div className="flex items-center gap-4">
                {iconObj.male === undefined ? (
                  <div class="relative inline-block">
                    <FontAwesomeIcon icon={faPlus} />
                    <input
                      type="file"
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      onChange={(e) => handleUploadIcons(e, "male")}
                    />
                  </div>
                ) : (
                  <>
                    <img alt="" className="h-10" src={iconObj?.male?.icon} />
                    <div class="relative inline-block">
                      <FontAwesomeIcon icon={faEdit} />
                      <input
                        type="file"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={(e) => handleUploadIcons(e, "male")}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="flex justify-between mt-2">
              <div>Female</div>
              <div className="flex items-center gap-4">
                {iconObj.female === undefined ? (
                  <div class="relative inline-block">
                    <FontAwesomeIcon icon={faPlus} />
                    <input
                      type="file"
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      onChange={(e) => handleUploadIcons(e, "female")}
                    />
                  </div>
                ) : (
                  <>
                    <img alt="" className="h-10" src={iconObj?.female?.icon} />
                    <div class="relative inline-block">
                      <FontAwesomeIcon icon={faEdit} />
                      <input
                        type="file"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={(e) => handleUploadIcons(e, "female")}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="flex justify-between mt-2">
              <div>Default</div>
              <div className="flex items-center gap-4">
                {iconObj.default === undefined ? (
                  <div class="relative inline-block">
                    <FontAwesomeIcon icon={faPlus} />
                    <input
                      type="file"
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      onChange={(e) => handleUploadIcons(e, "default")}
                    />
                  </div>
                ) : (
                  <>
                    <img alt="" className="h-10" src={iconObj?.default?.icon} />{" "}
                    <div class="relative inline-block">
                      <FontAwesomeIcon icon={faEdit} />
                      <input
                        type="file"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={(e) => handleUploadIcons(e, "default")}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        }
      />

      <Modal
        isOpen={transDis}
        onClose={() => setTransDis(false)}
        title="Page Translations"
        content={
          <PageHeaderTranslation
            currLang={transData}
            langList={languageList}
            editable={editable}
          />
        }
      />
    </>
  );
};

export default PageHeaderTable;
